import type { MeetingRecord } from '../models/meeting.model'

/**
 * The time range and minutes Meeting Details shows.
 *
 * - Start: always the booked start, even if people joined early.
 * - End: the booked end, or when the meeting really finished if it overran.
 *   After Mark as Past the booked end IS the moment it was marked (the server
 *   moves it), so that shows here too.
 * - Minutes: how long the meeting was actually in use — summed across every
 *   time anyone was in it (the server merges its rooms). While someone is in it
 *   right now, the booked duration. A meeting whose time is over with nobody
 *   ever having joined shows 0; one that has not happened yet shows the booking.
 */
export function displayedMeetingTimes(
  meeting: Pick<
    MeetingRecord,
    'startTimeMs' | 'endTimeMs' | 'duration' | 'status' | 'actualDurationMinutes' | 'actualEndTimeMs' | 'inProgress'
  >,
  now: number = Date.now(),
): { startMs: number; endMs: number; minutes: number } {
  const startMs = meeting.startTimeMs
  const endMs = Math.max(meeting.endTimeMs, meeting.actualEndTimeMs ?? 0)

  if (meeting.inProgress) return { startMs, endMs, minutes: meeting.duration }
  if (meeting.actualDurationMinutes != null) return { startMs, endMs, minutes: meeting.actualDurationMinutes }

  const over = meeting.status === 'completed' || meeting.status === 'expired' || meeting.endTimeMs <= now
  return { startMs, endMs, minutes: over ? 0 : meeting.duration }
}
